import React from 'react';
import WatchItem from '../../../../../components/Watch/WatchItem';

const WatchLists = ({ totalWatchData }) => {
  return (
    <div className="categories-watch categories-filters bg-dark categories-watch--detail pd-t-0">
      <div className="wrapper ">
        <div className="cat_watch-list">
          <div className="cat_watch-row">
            <div className="cat_watch-body">
              <div className="cat_watch-body-list">
                <div className="cat_watch-item">
                  <div className="watch_item-row columns-5 d-flex">
                    {!!totalWatchData?.nodes &&
                      totalWatchData?.nodes?.map((episodeItem, idx) => (
                        <WatchItem key={idx} data={episodeItem} className="cols watch_item-list" showPlayIcon />
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchLists;
